

<nav class="navbar navbar-expand-lg navbar-dark bg-dark  rounded ">
   <div class="container">
    <a class="navbar-brand mx-5">MovieApp</a>
    <button class="navbar-toggler" data-target="#my-nav" data-toggle="collapse" aria-controls="my-nav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
    </button>
    <div id="my-nav" class="collapse navbar-collapse ">


        <ul class="navbar-nav m-auto">
            <li class="nav-item active mx-3">
                <a *ngIf="isLogin" class="nav-link" routerLink="/home">Home <span class="sr-only">(current)</span></a>
            </li>
            
           
            <li class="nav-item active mx-3">
                <a *ngIf="isLogin" class="nav-link" routerLink="/tvshow">Tv Show <span class="sr-only">(current)</span></a>
            </li>
          
           
           

            

        </ul>



        <ul class="navbar-nav ml-auto ">



              <li class="nav-item active ">
              

            </li>


            <li class="nav-item active">
                <a *ngIf="isLogin" class="nav-link" (click)="logoutclick()"  routerLink="/logout">Logout <span class="sr-only">(current)</span></a>
            </li>
            
            <li class="nav-item active">
                <a *ngIf="!isLogin" class="nav-link" routerLink="/login">Login <span class="sr-only">(current)</span></a>
            </li>
            <li class="nav-item active">
                <a *ngIf="!isLogin" class="nav-link"   routerLink="/register">register <span class="sr-only">(current)</span></a>
            </li>
            
        </ul>
    </div>
   </div>
</nav>